import { brand, statusColors, themeColors } from '../theme'

export interface ShipmentStateDefinition {
  label: string
  color: string
}

// Source of truth: MineTrace.Shared.Enums.ShipmentState
// Any page that displays a ShipmentState must import from here — do NOT
// redefine a local map. Drift between pages is how we ended up with
// "Completo" showing for state=4 across the app.
export const SHIPMENT_STATE_MAP: Record<number, ShipmentStateDefinition> = {
  0: { label: 'Nuevo', color: themeColors.textMuted },
  1: { label: 'Generado', color: statusColors.info },
  2: { label: 'En Transito', color: brand.gold },
  3: { label: 'Desviado', color: statusColors.warning },
  4: { label: 'En Recepcion', color: statusColors.success },
  5: { label: 'Pesado y Muestreado', color: '#8B5CF6' },
  11: { label: 'Muestreado', color: '#6366F1' },
  6: { label: 'En Analisis', color: '#A855F7' },
  12: { label: 'En Conciliacion', color: '#06B6D4' },
  13: { label: 'Conciliado', color: '#14B8A6' },
  14: { label: 'Rechazado en Conciliacion', color: statusColors.error },
  7: { label: 'Liquidado', color: brand.green },
  8: { label: 'Finalizado', color: brand.green },
  9: { label: 'Cancelado', color: statusColors.error },
  10: { label: 'Rechazado', color: statusColors.error },
}

export const getShipmentState = (state: number): ShipmentStateDefinition =>
  SHIPMENT_STATE_MAP[state] ?? SHIPMENT_STATE_MAP[0]

export interface ShipmentStateBadge extends ShipmentStateDefinition {
  bg: string
}

export const getShipmentStateBadge = (state: number): ShipmentStateBadge => {
  const def = getShipmentState(state)
  return { ...def, bg: `${def.color}22` }
}
